import TaskMapTemplate from '../../../components/Templates/TaskMapTemplate/TaskMapTemplate';
import { MapProvider } from 'react-map-gl';

interface Props {
  editing: boolean;
}

function TaskMap({editing}: Props) {
  return (
    <MapProvider>
      <TaskMapTemplate editing={editing} />
    </MapProvider>
  );
}

export default TaskMap;
